import {MobileColumn} from '../../model/MobileColumn';
import {MFilterModalComponent} from '../../components/filter-modal/m-filter-modal.component';

const cols: Array<MobileColumn> = [
    {
        field: 'ED1_TYPE_TEXT',
        label: 'Type',
        type: MFilterModalComponent.TYPE_TEXT,
        filter: true,
        sort: false
    },
    {
        field: 'ED1_TYPE',
        label: 'Type',
        type: MFilterModalComponent.TYPE_TEXT,
        filter: false,
        sort: true
    },
    {
        field: 'ED1_DOCUMENT_NO',
        label: 'Document No',
        type: MFilterModalComponent.TYPE_TEXT,
        filter: true,
        sort: true
    },
    {
        field: 'ED1_STATUS',
        label: 'Status',
        type: MFilterModalComponent.TYPE_SELECT,
        filter: true,
        sort: true
    },
    {
        field: 'ED1_IN_OUT',
        label: 'In/Out',
        type: MFilterModalComponent.TYPE_SELECT,
        filter: true,
        sort: true
    }
];

export default cols;



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/views/transactions/m-transactions.cols.ts